/** Initials avatar (no upload needed). Colour is derived deterministically from
 * the email so a user's avatar is stable. */
export function Avatar({
  name,
  email,
  size = 32,
}: {
  name?: string | null;
  email: string;
  size?: number;
}) {
  const source = name?.trim() || email;
  const initials = source
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  let hash = 0;
  for (let i = 0; i < email.length; i++) hash = (hash * 31 + email.charCodeAt(i)) % 360;
  return (
    <span
      aria-hidden
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        backgroundColor: `hsl(${hash} 45% 30%)`,
        color: `hsl(${hash} 70% 85%)`,
      }}
      className="inline-flex flex-none items-center justify-center rounded-full font-semibold"
    >
      {initials}
    </span>
  );
}
